import vine from '@vinejs/vine'
import '~/validators/configureVine'
import { orgRichTextVine } from '~/validators/orgRichText'
import { createAndUpdateValidator, optionalLongLabelField, orgLibField } from '~/validators/orgFields'

const directionValidators = createAndUpdateValidator(function directionSchema() {
  return vine.object({
    dirLib: orgLibField(),
    dirLibLong: optionalLongLabelField(),
    dirDesc: orgRichTextVine().nullable(),
    dirType: vine.string().trim(),
  })
})

export const createDirectionValidator = directionValidators.create
export const updateDirectionValidator = directionValidators.update

export const patchDirectionValidator = vine.create(
  vine.object({
    dirLib: orgLibField().nullable().optional(),
    dirLibLong: optionalLongLabelField(),
    dirDesc: orgRichTextVine().nullable().optional(),
    dirType: vine.string().trim().optional(),
  })
)
